import './App.css';
import React from 'react';
import {
  BrowserRouter as Router ,
  Routes,
  Route
} from "react-router-dom";
import Navbar from './components/Navbar';
import { Home }   from './components/Home';
import About from './components/About';
import NoteState from './context/notes/NoteState';
import Alert from './components/Alert';
import Login from './components/Login';
import Signup from './components/Signup';
import { useState } from 'react';

function App() {
  const [alert, setAlert] = useState(null);
  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 8000)
  }
  return (
    <>
    <NoteState>
      <Router basename='/My-notes'>
        <Navbar /> 
        <Alert alert={alert}/>
        <div className='container'>
        <Routes>
          <Route exact path="/" element={<Home showAlert={showAlert} />}></Route>
          <Route exact path="/about" element={<About/>}></Route> 
          <Route exact path="/login" element={<Login showAlert={showAlert}/>}></Route> 
          <Route exact path="/signup" element={<Signup showAlert={showAlert}/>}></Route> 
        </Routes>
        </div>
      </Router>
      </NoteState>
    </>
  );
}

export default App;